var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { Button, Dialog, DialogContent } from '@material-ui/core';
import FormDataSource from '../data-source/FormDataSource';
import Form from '../Form';
import { useFormContext } from '../FormContext';
export const FormDialog = (_a) => {
    var { preview, formData, onCancel, onSubmit } = _a, props = __rest(_a, ["preview", "formData", "onCancel", "onSubmit"]);
    const { clearFormValues } = useFormContext();
    useEffect(() => {
        // clear form values each time dialog loads
        clearFormValues();
    }, [clearFormValues]);
    return (React.createElement(Dialog, Object.assign({ fullWidth: true, onClose: onCancel }, props),
        React.createElement(DialogContent, null,
            React.createElement(FormDataSource, { disabled: preview, formData: formData },
                React.createElement(Form, { values: formData, appendSectionControls: React.createElement(Button, { onClick: event => {
                            if (preview) {
                                clearFormValues();
                            }
                            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                        } }, "Close") })))));
};
export default FormDialog;
//# sourceMappingURL=FormDialog.js.map